import {ProjectControlItem} from "./projectControlItem";
import {EvidenceCentralItemLog} from "./evidenceCentralItem";

export class Device {
  deviceId: number;
  clientITProfileId: number;
  deviceName: string;
  type: string;
  manufacturer: string;
  model: string;
  serialNumber: string;
  ip: string;
  mac: string;
  puid: string;
  owner: string;
  location: string;
  clientITProfileName: string;
  projectControlItems: ProjectControlItem[];
  findings: EvidenceCentralItemLog[];
  devicePositions?: any[];
}
